<template>
  <div class="modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal-inner" :style="{alignItems: 'flex-start'}">
      <div class="edit-popup edit-popup--invoice-partially-paid">
        <div class="edit-popup__header edit-popup__header-invoice-partially-paid">
          <div class="edit-popup__title">
            <span>Amount Paid</span>
          </div>
          <div class="edit-popup__close" @click="closeModal">
            <svg width="1em" height="1em" class="icon icon-close">
              <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
            </svg>
          </div>
        </div>

        <div class="partially-paid-block">
          <div class="partially-paid-top">
            <div class="partially-paid-top_services"><span>Description of services</span></div>
            <div class="partially-paid-top_qty"><span>Qty</span></div>
            <div class="partially-paid-top_price"><span>Price</span></div>
            <div class="partially-paid-top_total"><span>Total Amount</span></div>
            <div class="partially-paid-top_paid"><span>Amount Paid</span></div>
          </div>
          <div class="partially-paid-item" v-for="(service, index) in invoice.services" :key="service.id">
            <div class="partially-paid-item_services">
              <template v-if="service.type === 'CUSTOM' || service.type === 'ADDITIONAL_OPTION'">
                <svg
                    width="20px"
                    height="20px"
                    class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                >
                <span>Custom</span>
              </template>
              <template v-if="service.type === 'OTHER_EXPENSES' || service.type === 'ADDITIONAL_SERVICE'">
                <svg
                    width="20px"
                    height="20px"
                    class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                >
                <span>Other</span>
              </template>
              <template v-if="service.type === 'AIRPORT_VIP_SERVICE'">
                <svg
                    width="20px"
                    height="20px"
                    class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                >
                <span>Airport</span>
              </template>
              <template v-if="service.type === 'TRANSFER'">
                <svg
                    width="20px"
                    height="20px"
                    class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                >
                <span>Transfer</span>
              </template>
              <template v-if="service.type === 'FLIGHT'">
                <svg
                    width="20px"
                    height="20px"
                    class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                >
                <span>Flight</span>
              </template>
              <template v-if="service.type === 'MAINLAND'">
                <svg
                    width="20px"
                    height="20px"
                    class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                >
                <span>Day Trips</span>
              </template>
              <template v-if="service.type === 'ISLAND' || service.type === 'ISLAND_TRANSFER' || service.type === 'ISLAND_DAY_TRIP'">
                <svg
                    width="20px"
                    height="20px"
                    class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                >
                <span>Island</span>
              </template>
              <template v-if="service.type === 'SAFARI' || service.type === 'SAFARI_ACTIVITY'">
                <svg
                    width="20px"
                    height="20px"
                    class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                >
                <span>Safari</span>
              </template>
              <template v-if="service.type === 'CLIMBING' || service.type === 'CLIMBING_RENTAL' || service.type === 'CLIMBING_EXTRA'">
                <svg
                    width="20px"
                    height="20px"
                    class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                >
                <span>Climbing</span>
              </template>
              <template v-if="service.type === 'EXTRA_ACCOMMODATION'">
                <svg
                    width="20px"
                    height="20px"
                    class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                >
                <span>Extra Accommodation</span>
              </template>
            </div>
            <div class="partially-paid-item_desc">
              <span>{{service.name}}</span>
            </div>
            <div class="partially-paid-item_qty">
              <span>{{service.quantity}}</span>
            </div>
            <div class="partially-paid-item_price">
              <span>{{getCurrencySign(invoice.currencyType)}} {{numberWithCommas(service.price)}}</span>
            </div>
            <div class="partially-paid-item_total">
              <span>{{getCurrencySign(invoice.currencyType)}} {{numberWithCommas(service.amount)}}</span>
            </div>
            <div class="partially-paid-item_paid">
              <span>{{getCurrencySign(invoice.currencyType)}} {{numberWithCommas(service.amountPaid)}}</span>
            </div>
          </div>


          <div class="partially-paid-options">
            <div class="partially-paid-options_data">
              <div class="data_select-payment">
                <span class="title">Payment Method:</span>
                <span class="desc">{{parseDateToString(invoice.dateOfPayment)}}</span>
              </div>
              <div class="data_datePayment">
                <span class="title">Date of Payment:</span>
                <span class="desc">{{ invoice.paymentMethod }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import {format, parse} from "date-fns";
import {getCurrencySign} from '../../../common/helpers/currency'

export default {
  name: 'AtModalInvoiceAmountPaid',
  props: {
    invoice: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
    }
  },
  methods: {
    getCurrencySign,
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    parseDateToString(date) {
      if (!date) return
      return format(parse(date, 'dd.MM.yyyy', new Date()), 'dd MMM yyyy')
    },
    closeModal() {
      // console.log('closeModal')
      this.$emit('closeModalInvoiceAmountPaidOptions', false)

    },
  },
  mounted() {

  }
}
</script>
<style lang="scss" scoped>
.edit-popup {
  padding: 20px 35px 35px 35px;
}
.edit-popup--invoice-partially-paid {
  width: 705px;

  .partially-paid-block {
    .partially-paid-top {
      display: grid;
      grid-template-columns: 300px 27px 94px 100px 74px;
      grid-column-gap: 10px;

      padding-top: 20px;
      padding-bottom: 18px;

      border-bottom: 1px solid #E6E6E6;

      span {
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;

        color: #1A1A1A;
      }
    }
    .partially-paid-item {
      display: grid;
      grid-template-columns: 102px 189px 25px 95px 100px 74px;
      grid-column-gap: 10px;

      align-items: center;
      padding-top: 10px;
      padding-bottom: 10px;

      border-bottom: 1px solid #E6E6E6;

      .partially-paid-item_services {
        display: flex;
        align-items: center;

        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        svg {
          width: 20px;
          height: 20px;
        }
        span {
          width: 75px;

          display: block;

          font-weight: 500;
          font-size: 14px;
          line-height: 17px;

          color: #1A1A1A;

          padding-left: 7px;
        }
      }
      .partially-paid-item_desc {
        text-overflow: ellipsis;
        overflow: hidden;
        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;

          color: #000000;
        }
      }
      .partially-paid-item_qty {
        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;

          color: #000000;
        }
      }
      .partially-paid-item_price {
        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;

          color: #606060;
        }
      }
      .partially-paid-item_total {
        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;

          color: #606060;
        }
      }
      .partially-paid-item_paid {
        text-align: center;
        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;

          color: #000000;
        }
      }
    }

    .partially-paid-options {
      padding-top: 47px;

      display: flex;
      align-items: center;


      .partially-paid-options_data {
        display: flex;
        align-items: center;
        .title {
          font-weight: 500;
          font-size: 12px;
          line-height: 14px;

          color: #1A1A1A;
          padding-bottom: 7px;
        }

        .desc {
          padding-left: 7px;
          font-weight: 400;
          font-size: 12px;
          line-height: 14px;

          color: #686868;
        }


        .data_select-payment {
          //width: 333px;

          margin-right: 20px;


        }

        .data_datePayment {
          //width: 130px;
        }
      }
    }
  }
}
</style>
